"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class LoadingView extends React.PureComponent {
    render() {
        return React.createElement("div", { className: 'shimmer-container column' },
            React.createElement("div", { className: 'padder' }),
            React.createElement("div", { className: 'shimmer avatar' }),
            React.createElement("div", { className: 'shimmer title' }),
            React.createElement("div", { className: 'shimmer title' }),
            React.createElement("div", { className: 'shimmer primary-button' }),
            React.createElement("div", { className: 'shimmer secondary-button' }),
            React.createElement("div", { className: 'shimmer description' }),
            React.createElement("div", { className: 'padder' }));
    }
}
exports.LoadingView = LoadingView;
